const isArray = (data) => {
  return Array.isArray(data) ? data : [];
};

export default isArray;
